function EquatorialGuinea({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1127)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M9.73908 10.4348H31.0047C28.7441 4.342 22.8793 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L9.73908 10.4348Z" fill="#6DA544"/>
        <path d="M9.73908 21.5654H31.0047C28.7441 27.6582 22.8793 32.0002 15.9999 32.0002C11.5816 32.0002 7.58202 30.2091 4.68677 27.3134L9.73908 21.5654Z" fill="#D80027"/>
        <path d="M4.68628 4.68604C-1.56209 10.9344 -1.56209 21.0651 4.68628 27.3135C7.26834 24.7315 9.75165 22.2482 16 15.9998L4.68628 4.68604Z" fill="#0052B4"/>
        <path d="M18.7826 13.2173V16.6955C18.7826 18.8255 21.5652 19.4782 21.5652 19.4782C21.5652 19.4782 24.3478 18.8255 24.3478 16.6955V13.2173H18.7826Z" fill="#DEDDE0"/>
        <path d="M20.8695 16.0693H22.2608V18.0867H20.8695V16.0693Z" fill="#786145"/>
        <path d="M22.9565 15.3044C22.9565 14.536 22.3336 13.9131 21.5652 13.9131C20.7968 13.9131 20.1739 14.536 20.1739 15.3044C19.7897 15.3044 19.4783 15.6158 19.4783 16C19.4783 16.3842 19.7897 16.6956 20.1739 16.6956H22.9565C23.3407 16.6956 23.6521 16.3842 23.6521 16C23.6521 15.6158 23.3408 15.3044 22.9565 15.3044Z" fill="#6DA544"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default EquatorialGuinea;
